export default "__VITE_ASSET__f9e2bf88__"